export default "/dist/files/choix_animation_concours_photo.0dcecaac9a10715c67f304196a0afe91.svg";